<template>
  <div :id="markdownId" class="cymarkdown" :class="{ 'with-toc': readonly && showToc }" :style="markdownStyle" />
</template>

<script>
import 'cherry-markdown/dist/cherry-markdown.css'
import commonService from '@/api/common'
import { getUploadType, getFileMd5 } from '@/utils/fileUtil'
import { CherryMarkdown } from './util'

export default {
  name: 'CherryMarkdown',
  props: {
    markdownId: {
      type: String,
      default: 'markdown-container'
    },
    content: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxHeight: Number,
    minHeight: Number,
    height: Number,
    showToc: Boolean
  },
  data() {
    return {
      cherryInstance: null
    }
  },
  computed: {
    markdownStyle() {
      const style = {}
      if (this.maxHeight) {
        style.maxHeight = `${this.maxHeight}px`
        style.overflowY = 'auto'
      }

      if (this.minHeight) {
        style.minHeight = `${this.minHeight}px`
      }

      return style
    }
  },
  watch: {
    content: {
      handler: 'setContent',
    }
  },
  mounted() {
    this.setContent()
  },
  destroyed() {
    this.cherryInstance = null
  },
  methods: {
    init() {
      this.cherryInstance = new CherryMarkdown({
        id: this.markdownId,
        value: this.content,
        isPreviewOnly: this.readonly,
        editor: {
          height: `${this.height}px`
        },
        fileUpload: async(file, callback) => {
          console.log('markdown file upload, params:', file)
          try {
            const ext = file.name.split('.').pop()
            const uploadType = getUploadType(ext)
            const extraParams = {
              bucket: 'pic'
            }
            if (['track', 'video'].includes(uploadType)) {
              if (file.size > 1024 * 1024 * 100) {
                throw new Error('文件大小不能超过100M')
              }

              extraParams.md5 = await getFileMd5(file)
            }

            const resp = await commonService.upload(getUploadType(ext), file, extraParams)
            const urlObj = new URL(resp.url)
            urlObj.hostname = 'img.tencentmusic.com'
            callback(urlObj.toString())
          } catch (error) {
            this.$alert(`上传文件异常: ${error.message}`, '错误', {
              type: 'error'
            })
          }
        }
      })
    },
    getContent() {
      return this.cherryInstance ? this.cherryInstance.getMarkdown() : ''
    },
    setContent() {
      if (!this.cherryInstance) {
        this.init()
      }

      this.cherryInstance.setValue(this.content)
      if (this.showToc && this.readonly) {
        this.cherryInstance.insert('[[toc]]\n')
      }
    }
  }
}
</script>

<style lang="scss">
.cymarkdown {
  .cherry {
    background-color: #fff;
    box-shadow: none;
  }

  .cherry-previewer {
    padding-top: 0;
    border-left: none;
    background-color: #fff;
  }
}

.with-toc {
  .cherry-previewer {
    width: 100%;
    height: 100%;
    margin-right: 300px;
    overflow: unset;

    .toc {
      position: absolute;
      right: 0px;
      top: 0px;
      padding: 10px;
      width: 300px;
      z-index: 1;
    }
  }
}
</style>
